// ...new file...
const theme = {
  fonts: {
    base: '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial',
    heading: '"Inter", system-ui, Roboto, Arial, sans-serif'
  },
  colors: {
    primary: '#0b69ff',
    primaryHover: '#0958e6',
    accent: '#1976d2',
    bg: '#f6f8fb',
    cardBg: '#ffffff',
    muted: '#7b8794',
    border: '#e6eef8',
    danger: '#d32f2f'
  },
  radii: {
    sm: 6,
    md: 10,
    lg: 12
  },
  spacing: {
    xs: 6,
    sm: 12,
    md: 20,
    lg: 28
  },
  shadows: {
    soft: '0 6px 18px rgba(12,20,40,0.06)',
    pop: '0 8px 30px rgba(2,6,23,0.08)'
  }
};

export default theme;